import { get, post, put, del, postMultipart, putFilesProfile, getPdf } from '@webapps/utils';

// const NX_REST_API = 'http://127.0.0.1:8080';

const { NX_REST_API } = process.env;

export const getInfosCFA = {
  query: ({ id }) =>
    get({
      url: `${NX_REST_API}/cfa/${id}`,
    }),
  format: ({ data }) => data,
};

export const getRelationsByCFA = {
  query: ({ id, size, page }) =>
    get({
      url: `${NX_REST_API}/cfa/relations/${id}?size=${size}&page=${page}`,
    }),
  format: ({ data }) => data,
};

export const getRelationsBySchool = {
  query: ({ id }) =>
    get({
      url: `${NX_REST_API}/cfa/relations/school/${id}`,
    }),
  format: ({ data }) => data,
};

export const deleteRelation = {
  query: ({ id, from }) =>
    del({
      url: `${NX_REST_API}/cfa/relations/${id}?from=${from}`,
    }),
};

export const searchRelations = {
  query: ({ id, schoolsId, size, page }) =>
    get({
      url: `${NX_REST_API}/cfa/relations/search/${id}?size=${size}&page=${page}`,
      options: {
        params: {
          ...(schoolsId ? { schoolsId } : {}),
        }
      }
    }),
  format: ({ data }) => data,
}

export const searchTrainingsByRelations = {
  query: ({ id, schoolsId, trainingLabel, rncp, diplomaCode, size, page }) =>
    get({
      url: `${NX_REST_API}/cfa/relations/searchTrainings/${id}?size=${size}&page=${page}`,
      options: {
        params: {
          ...(schoolsId ? { schoolsId } : {}),
          ...(trainingLabel ? { trainingLabel } : {}),
          ...(rncp ? { rncp } : {}),
          ...(diplomaCode ? { diplomaCode } : {}),
        }
      }
    }),
  format: ({ data }) => data,
};

export const searchOpcoRecords = {
  query: ({ id, schoolsId, trainingLabel, studentName, opcos, opcoStatus, contractStatus, order, size, page }) =>
    get({
      url: `${NX_REST_API}/cfa/opco/record/search/${id}?size=${size}&page=${page}`,
      options: {
        params: {
          ...(schoolsId ? { schoolsId } : {}),
          ...(trainingLabel ? { trainingLabel } : {}),
          ...(studentName ? { studentName } : {}),
          ...(opcos ? { opcos } : {}),
          ...(opcoStatus ? { opcoStatus } : {}),
          ...(contractStatus ? { contractStatus } : {}),
          ...(order ? { order } : {}),
        }
      }
    }),
  format: ({ data }) => data,
}

export const searchOpcoBillings = {
  query: ({ id, schoolsId, trainingLabel, studentName, billingStatus, opcos, opcoRecordsId, size, page }) =>
    get({
      url: `${NX_REST_API}/cfa/opco/billing/search/${id}?size=${size}&page=${page}`,
      options: {
        params: {
          ...(schoolsId ? { schoolsId } : {}),
          ...(trainingLabel ? { trainingLabel } : {}),
          ...(studentName ? { studentName } : {}),
          ...(billingStatus ? { billingStatus } : {}),
          ...(opcos ? { opcos } : {}),
          ...(opcoRecordsId ? { opcoRecordsId } : {}),
        }
      }
    }),
  format: ({ data }) => data,
}

export const getCFAsBySchool = {
  query: ({ id }) =>
    get({
      url: `${NX_REST_API}/cfa/school/${id}`,
    }),
  format: ({ data }) => data,
};

export const getOPCOsByCFA = {
  query: ({ id }) =>
    get({
      url: `${NX_REST_API}/cfa/opco/cfa/${id}`,
    }),
  format: ({ data }) => data,
};

export const addOPCOtoCFA = {
  query: ({ data }) =>
    post({
      url: `${NX_REST_API}/cfa/opco`,
      data
    }),
};

export const updateOPCOtoCFA = {
  query: ({ id, action }) =>
    put({
      url: `${NX_REST_API}/cfa/opco/${id}?action=${action}`,
    }),
};

export const generateContract = {
  query: ({ id, formData }) =>
    postMultipart({
      url: `${NX_REST_API}/cfa/contracts/${id}`,
      formData,
    }),
}

export const uploadCerfa = {
  query: ({ id }) =>
    post({
      url: `${NX_REST_API}/cfa/opco/record/cerfa/${id}`,
    }),
}

export const getConventionModel = {
  query: ({ id }) =>
    get({
      url: `${NX_REST_API}/cfa/convention/models/model/${id}`,
    }),
  format: ({ data }) => data,
};

export const disableNewVersion = {
  query: ({ id }) =>
    put({
      url: `${NX_REST_API}/cfa/convention/models/model/${id}/disable-new-version`,
    }),
}

export const getAllConventionModels = {
  query: ({ id }) =>
    get({
      url: `${NX_REST_API}/cfa/convention/models/${id}`,
    }),
  format: ({ data }) => data,
}

export const updateConventionModel = {
  query: ({ id, data }) =>
    put({
      url: `${NX_REST_API}/cfa/convention/models/${id}`,
      data
    }),
}

export const deleteConventionModel = {
  query: ({ id }) =>
    del({
      url: `${NX_REST_API}/cfa/convention/models/${id}`,
    }),
  format: ({ data }) => data,
}

export const previewConventionModel = {
  query: ({ id, formData }) =>
    postMultipart({
      url: `${NX_REST_API}/cfa/convention/models/preview/${id}`,
      formData,
    }),
  format: ({ data }) => data,
};

export const saveBilling = {
  query: ({ id, data }) =>
    post({
      url: `${NX_REST_API}/cfa/opco/billing/${id}`,
      data,
    }),
}

export const generateBilling = {
  query: ({ billingId, recordId, formData }) =>
    postMultipart({
      url: `${NX_REST_API}/cfa/opco/billing/generate/${billingId}/${recordId}`,
      formData,
    }),
}

export const addRQTH = {
  query: ({ id, data }) =>
    post({
      url: `${NX_REST_API}/cfa/opco/record/rqth/${id}`,
      data,
    }),
  format: ({ data }) => data,
}

export const getBillingsYearlyHistory = {
  query: ({ id, year }) =>
    get({
      url: `${NX_REST_API}/cfa/opco/billing/history/${year}/${id}`,
    }),
  format: ({ data }) => data,
}

export const getBillingsStats = {
  query: ({ id }) =>
    get({
      url: `${NX_REST_API}/cfa/opco/billing/stats/${id}`,
    }),
  format: ({ data }) => data,
}

export const getCfaActions = {
  query: ({ id, size, page }) =>
    get({
      url: `${NX_REST_API}/cfa/actions/${id}?size=${size}&page=${page}`,
    }),
  format: ({ data }) => data,
}

export const getDashboardStats = {
  query: ({ id }) =>
    get({
      url: `${NX_REST_API}/cfa/stats/${id}`,
    }),
  format: ({ data }) => data,
}

export const getRecordDocumentsList = {
  query: ({ id }) =>
    get({
      url: `${NX_REST_API}/cfa/opco/record/documents/${id}`,
    }),
  format: ({ data }) => data,
}

export const getOodriveDocument = {
  query: ({ id, type }) =>
    getPdf({
      url: `${NX_REST_API}/cfa/contracts/${id}/download?type=${type}`,
    }),
  format: ({ data }) => data,
}

export const getConventionByRecord = {
  query: ({ id }) =>
    get({
      url: `${NX_REST_API}/cfa/convention/models/record/${id}/model`,
    }),
  format: ({ data }) => data,
}
